import React from 'react';

import styles from './Sale.module.less';
import AutoPageTurn from '../AutoPageTurn';
import GameLink from '../GameLink';

export default ({ title, operate, to, tag: source, data = [] }) => {
  return (
    <AutoPageTurn
      size={data.length}
      title={title}
      operate={operate}
      to={to}
      source={source}>
      <nav className={styles.Sale}>
        {
          data
            .map((good, index) => {
              return (
                <GameLink
                  key={index}
                  info={good}
                  source={source}
                  data={good}
                  logInfo={{
                    category: 'C',
                    action: 'Game_Non_Button',
                    params: {
                      id: good.id || '',
                      type: 'sell',
                      source,
                    },
                    bizInfo: good.bizInfo,
                  }}>
                  <header>
                    <b style={{backgroundImage: `url("${good.imgUrl}")`}}>
                    </b>
                  </header>
                  <section>
                    <div>
                      <h1 title={good.name}>{good.name}</h1>
                      <p>{good.proDesc}</p>
                    </div>
                    <div className={good.originalPrice ? '' : 'middle'}>
                      <h1>￥{good.nowPrice}</h1>
                      {good.originalPrice && <p>￥{good.originalPrice}</p>}
                    </div>
                  </section>
                  {good.cornerText && <span>{good.cornerText}</span>}
                </GameLink>
              )
            })
        }
      </nav>
    </AutoPageTurn>
  );
};
